export default "__VITE_ASSET__D5Mu3mje__"